import { createSelector } from 'reselect'

export default createSelector(
  (state) => Object.values(state.notificationCenter.notifications),
  (notifications) => notifications.slice(-4),
)
